import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=08f5d200&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=08f5d200&prod&lang=less&scoped=true"
import style1 from "@/assets/style/pages/login.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5d200",
  null
  
)

export default component.exports